var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _path35, _path36, _line, _line2, _rect11, _path37, _path38, _line3, _line4, _rect12, _path39, _path40, _line5, _line6, _rect13, _path41, _path42, _line7, _line8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationModalMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 183,
    viewBox: "0 0 237 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 105V99.9998L55.5 102.5L52 105Z",
    fill: "#765697",
    stroke: "#765697"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.44952 155.578C1.44952 155.578 6.53264 155.291 10.8998 155.291C14.8732 155.291 20.3501 155.596 20.3501 155.596L10.3987 158.968L1.44952 155.578Z",
    fill: "#3E1A68"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95741 133.555H2.61273V147.095",
    stroke: "#18B2A3",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32462 150.162H4.83215C4.63527 150.162 4.47418 150.001 4.47418 149.803V132.874C4.47418 132.676 4.63527 132.515 4.83215 132.515H9.32462C9.5215 132.515 9.68259 132.676 9.68259 132.874V149.803C9.68259 150.019 9.5215 150.162 9.32462 150.162Z",
    fill: "#FFC700"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69833 148.638H5.45874V166.285H8.69833V148.638Z",
    fill: "#FFC700"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69833 150.162H5.45874V151.041H8.69833V150.162Z",
    fill: "#6A2EAF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69833 131.636H5.45874V132.515H8.69833V131.636Z",
    fill: "#6A2EAF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6407 163.612L10.9 163.039L14.8555 137.124L17.4328 133.555L18.5962 137.698L14.6407 163.612Z",
    fill: "#18B2A3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8555 137.124L17.4328 133.555L18.5962 137.698L14.8555 137.124Z",
    fill: "#FFC700"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5913 134.739L17.4325 133.555L17.8263 134.918L16.5913 134.739Z",
    fill: "#6A2EAF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8998 182.82C16.1261 182.82 20.3501 178.588 20.3501 173.351V155.668C20.3501 155.65 20.3501 155.632 20.3501 155.632C20.3501 155.632 14.4616 156.332 10.8998 156.332C6.72952 156.332 1.44952 155.632 1.44952 155.632V173.333C1.44952 178.588 5.67352 182.82 10.8998 182.82Z",
    fill: "#197DD8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3501 165.406C20.3501 165.406 14.4616 166.106 10.8998 166.106C6.72952 166.106 1.44952 165.406 1.44952 165.406V170.159C1.44952 170.159 6.72952 170.858 10.8998 170.858C14.4616 170.858 20.3501 170.159 20.3501 170.159C20.3501 170.159 20.3501 170.177 20.3501 170.195V165.442C20.3501 165.424 20.3501 165.406 20.3501 165.406Z",
    fill: "#FFC700"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9897 183H36.5301C36.1722 183 35.8858 182.731 35.85 182.372L33.8454 155.704C33.8096 155.31 34.1318 154.969 34.5255 154.969H52.0122C52.4059 154.969 52.7102 155.31 52.6923 155.704L50.6698 182.372C50.634 182.713 50.3476 183 49.9897 183Z",
    fill: "#2367AF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0122 164.581H34.5255C34.1318 164.581 33.8275 164.922 33.8454 165.317L34.4718 173.566C34.4897 173.925 34.794 174.194 35.152 174.194H51.3857C51.7437 174.194 52.0301 173.925 52.0659 173.566L52.6923 165.317C52.7102 164.904 52.4059 164.581 52.0122 164.581Z",
    fill: "#FFC700"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2416 153.606C35.2237 153.946 35.4743 154.233 35.8144 154.233H50.7058C51.0458 154.233 51.3143 153.946 51.2785 153.606L51.1711 152.081C51.1532 151.812 50.9205 151.615 50.67 151.615H35.886C35.6175 151.615 35.4027 151.83 35.3848 152.081L35.2416 153.606Z",
    fill: "#D6A712"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.861 156.421C32.8252 156.852 33.1653 157.228 33.6128 157.228H52.925C53.3546 157.228 53.6947 156.852 53.6768 156.421L53.5336 154.449C53.5157 154.108 53.2114 153.839 52.8713 153.839H33.6665C33.3264 153.839 33.04 154.108 33.0042 154.449L32.861 156.421Z",
    fill: "#FFC700"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M206.098 26.1299C206.098 24.4262 204.72 23.0632 203.038 23.0632H34.9546C33.2543 23.0632 31.894 24.4441 31.894 26.1299V125.592H206.116V26.1299H206.098Z",
    fill: "#5C616D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M206.099 125.593H31.8765V139.438C31.8765 141.608 33.6306 143.347 35.7784 143.347H202.179C204.344 143.347 206.081 141.59 206.081 139.438V125.593H206.099Z",
    fill: "#D8DBE5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M144.421 160.277C136.474 153.444 136.904 143.347 136.904 143.347H121.994H115.998H101.089C101.089 143.347 101.519 153.444 93.5718 160.277C92.2652 161.389 91.3524 163.254 98.3685 163.254C102.664 163.254 110.539 163.254 115.998 163.254C119.471 163.254 121.994 163.254 121.994 163.254C127.471 163.254 135.346 163.254 139.624 163.254C146.64 163.254 145.71 161.389 144.421 160.277Z",
    fill: "#BABECC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M136.903 143.365H121.994H115.998H101.089C101.089 143.365 101.143 144.692 100.839 146.719H137.154C136.85 144.692 136.903 143.365 136.903 143.365Z",
    fill: "#969AA3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M201.785 27.4749H36.1362V121.18H201.785V27.4749Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M213.652 163.703V181.511C213.652 182.246 217.929 182.838 223.192 182.838C228.454 182.838 232.731 182.246 232.731 181.511V163.703H213.652Z",
    fill: "#2367AF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M223.192 173.118C217.912 173.118 213.652 172.526 213.652 171.791V174.23C213.652 174.965 217.929 175.557 223.192 175.557C228.472 175.557 232.731 174.965 232.731 174.23V171.791C232.749 172.526 228.472 173.118 223.192 173.118Z",
    fill: "#FFC700"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M232.284 164.097C232.588 163.971 232.749 163.828 232.749 163.684C232.749 162.949 228.472 162.357 223.209 162.357C217.947 162.357 213.67 162.949 213.67 163.684C213.67 163.846 213.902 164.007 214.314 164.169C215.263 163.595 218.95 163.164 223.371 163.164C227.577 163.182 231.156 163.559 232.284 164.097Z",
    fill: "#18B2A3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M232.284 164.097C231.156 163.559 227.595 163.164 223.353 163.164C218.932 163.164 215.245 163.595 214.296 164.169C215.674 164.671 219.147 165.012 223.192 165.012C227.434 165.012 231.031 164.635 232.284 164.097Z",
    fill: "#18B2A3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M213.043 146.288C212.112 145.481 211.253 144.549 210.681 143.401C209.32 140.783 209.678 137.178 211.504 134.972C212.649 133.573 214.386 132.551 214.744 130.686C214.94 129.628 214.636 128.534 214.6 127.458C214.529 125.521 215.406 123.566 216.838 122.454C217.625 121.844 218.61 121.432 219.075 120.499C219.343 119.961 219.397 119.315 219.487 118.706C219.755 117.02 220.453 115.37 221.634 114.294C222.816 113.218 224.498 112.77 225.912 113.433C227.881 114.348 228.722 116.948 229.187 119.315C229.402 120.463 229.599 121.647 230.172 122.633C231.067 124.211 232.713 125.001 233.913 126.274C235.488 127.96 236.257 130.542 235.881 132.963C235.667 134.38 235.094 135.725 235.165 137.16C235.255 138.846 236.257 140.298 236.508 141.948C236.848 144.154 235.774 146.414 234.217 147.777C231.389 150.234 227.04 150.431 223.603 150.503C219.862 150.557 215.943 148.835 213.043 146.288Z",
    fill: "#18B2A3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M223.907 164.689C221.473 160.259 220.113 154.7 220.453 149.642C221.026 141.464 225.357 133.501 223.889 125.431",
    stroke: "#17023F",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M221.778 142.325C222.78 142.504 223.8 142.504 224.82 142.451C225.697 142.415 226.592 142.325 227.398 141.966C228.203 141.608 228.901 140.908 229.062 140.047",
    stroke: "#17023F",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M224.105 130.739C222.512 130.434 221.026 129.609 219.898 128.444",
    stroke: "#17023F",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M222.995 158.645C222.494 157.82 222.35 156.762 222.69 155.865C223.174 154.61 224.462 153.874 225.662 153.283C226.879 152.691 228.185 152.081 228.847 150.915C229.116 151.453 229.402 152.009 229.671 152.547C230.011 153.247 230.369 153.946 230.512 154.717C230.78 156.152 230.226 157.658 229.223 158.717C227.416 160.564 224.498 161.12 222.995 158.645Z",
    fill: "#18B2A3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M219.737 158.663C220.06 157.964 220.06 157.103 219.702 156.421C219.183 155.471 218.091 155.022 217.071 154.682C216.05 154.341 214.941 153.982 214.296 153.121C214.135 153.588 213.974 154.036 213.813 154.502C213.616 155.094 213.401 155.686 213.366 156.314C213.312 157.479 213.885 158.627 214.797 159.345C216.426 160.654 218.789 160.797 219.737 158.663Z",
    fill: "#18B2A3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M215.656 156.385C218.126 159.811 220.972 159.721 221.527 159.362",
    stroke: "#17023F",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M222.154 160.725C222.941 160.689 226.628 158.573 228.472 154.484",
    stroke: "#17023F",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5178 66.2859C54.5621 70.5454 57.1256 74.2771 60.7268 76.7802C64.3279 79.2832 68.7191 80.3854 73.0755 79.8797C77.4319 79.374 81.4538 77.2953 84.3858 74.0339C87.3179 70.7725 88.9584 66.5528 88.9992 62.1673L71 61.9998L53.5178 66.2859Z",
    fill: "#FCAF45"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8458 70.5386C88.8998 66.7269 89.511 62.3025 88.5673 58.0767C87.6236 53.8508 85.1882 50.1068 81.7077 47.531C78.2273 44.9553 73.9349 43.7204 69.6178 44.0529C65.3007 44.3854 61.2481 46.2629 58.203 49.3412L71 61.9998L86.8458 70.5386Z",
    fill: "#F02D2D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1188 46.3433C58.4144 48.4446 55.5751 51.7914 54.1056 55.7887C52.636 59.7859 52.6314 64.1748 54.0925 68.1752L71 61.9998L62.1188 46.3433Z",
    fill: "#3B5998"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 61.9998,
    r: 13,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 39.9998,
    width: 5,
    height: 43,
    fill: "#18B2A3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 44.7775,
    width: 5,
    height: 38.2222,
    fill: "#18B2A3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 48.3608,
    width: 5,
    height: 34.6389,
    fill: "#18B2A3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 53.1387,
    width: 5,
    height: 29.8611,
    fill: "#18B2A3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 56.722,
    width: 5,
    height: 26.2778,
    fill: "#18B2A3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 59.1108,
    width: 5,
    height: 23.8889,
    fill: "#18B2A3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 62.6942,
    width: 5,
    height: 20.3056,
    fill: "#18B2A3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 66.2775,
    width: 5,
    height: 16.7222,
    fill: "#18B2A3"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 71.0553,
    width: 5,
    height: 11.9444,
    fill: "#18B2A3"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 34.4998,
    width: 56,
    height: 54,
    rx: 2.5,
    stroke: "#E5E5E5"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 103.5,
    y: 34.4998,
    width: 92,
    height: 54,
    rx: 2.5,
    stroke: "#E5E5E5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 95.4998,
    width: 34.8947,
    height: 21,
    rx: 2.5,
    stroke: "#E5E5E5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M42 94.9998C42 93.3429 43.3431 91.9998 45 91.9998H74.8947C76.5516 91.9998 77.8947 93.3429 77.8947 94.9998V108H42V94.9998Z",
    fill: "#765697"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M57 103V96.9998L64 99.9998L57 103Z",
    fill: "#C1AADA"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 45.4737,
    y1: 110.5,
    x2: 61.6842,
    y2: 110.5,
    stroke: "#B5B9BF"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 45.4737,
    y1: 113.5,
    x2: 55.8947,
    y2: 113.5,
    stroke: "#B5B9BF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 81.8684,
    y: 95.4998,
    width: 34.8947,
    height: 21,
    rx: 2.5,
    stroke: "#E5E5E5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3684 94.9998C81.3684 93.3429 82.7116 91.9998 84.3684 91.9998H114.263C115.92 91.9998 117.263 93.3429 117.263 94.9998V108H81.3684V94.9998Z",
    fill: "#765697"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M96 103V96.9998L102 99.9998L96 103Z",
    fill: "#C1AADA"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 84.8421,
    y1: 110.5,
    x2: 101.053,
    y2: 110.5,
    stroke: "#B5B9BF"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 84.8421,
    y1: 113.5,
    x2: 95.2632,
    y2: 113.5,
    stroke: "#B5B9BF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 121.237,
    y: 95.4998,
    width: 34.8947,
    height: 21,
    rx: 2.5,
    stroke: "#E5E5E5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M120.737 94.9998C120.737 93.3429 122.08 91.9998 123.737 91.9998H153.632C155.288 91.9998 156.632 93.3429 156.632 94.9998V108H120.737V94.9998Z",
    fill: "#765697"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M136 103V96.9998L142 99.9998L136 103Z",
    fill: "#C1AADA"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 124.211,
    y1: 110.5,
    x2: 140.421,
    y2: 110.5,
    stroke: "#B5B9BF"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 124.211,
    y1: 113.5,
    x2: 134.632,
    y2: 113.5,
    stroke: "#B5B9BF"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 160.605,
    y: 95.4998,
    width: 34.8947,
    height: 21,
    rx: 2.5,
    stroke: "#E5E5E5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M160.105 94.9998C160.105 93.3429 161.448 91.9998 163.105 91.9998H193C194.657 91.9998 196 93.3429 196 94.9998V108H160.105V94.9998Z",
    fill: "#765697"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M175 103V96.9998L182 99.9998L175 103Z",
    fill: "#C1AADA"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 163.579,
    y1: 110.5,
    x2: 179.789,
    y2: 110.5,
    stroke: "#B5B9BF"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 163.579,
    y1: 113.5,
    x2: 174,
    y2: 113.5,
    stroke: "#B5B9BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationModalMobile);
export default __webpack_public_path__ + "static/media/Illustration-modal-mobile.bc00e95851accda4ab7715ff34989209.svg";
export { ForwardRef as ReactComponent };